var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoXplora = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "Logo-Xplora_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 112.21 111.07"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Logo-Xplora_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h112.21v111.07H0z",
  style: {
    fill: "none"
  }
})), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Logo-Xplora_svg__cls-4{fill:#e43012}"))), /*#__PURE__*/React.createElement("path", {
  d: "M23.23 14.54h72.72v77.59H23.23z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#Logo-Xplora_svg__clip-path)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M85.54 77a.44.44 0 0 0 .26-.45.4.4 0 0 0-.24-.41 1.25 1.25 0 0 0-.51-.1h-.62v1.07H85a1.6 1.6 0 0 0 .56-.11",
  className: "Logo-Xplora_svg__cls-4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M83.07 79.37a2.75 2.75 0 0 0 2 .83 2.7 2.7 0 0 0 1.1-.22 2.8 2.8 0 0 0 .89-.61 2.8 2.8 0 0 0 .83-2 2.9 2.9 0 0 0-.22-1.1 2.7 2.7 0 0 0-.61-.9 2.82 2.82 0 0 0-4 0 2.7 2.7 0 0 0-.61.9 2.84 2.84 0 0 0 0 2.19 2.9 2.9 0 0 0 .61.9m.69-3.89h1.32a2 2 0 0 1 .51.06 1.3 1.3 0 0 1 .45.19 1 1 0 0 1 .32.34 1 1 0 0 1 .12.52.92.92 0 0 1-.24.66 1.16 1.16 0 0 1-.63.35l1 1.65h-.8l-.88-1.58h-.49v1.58h-.67ZM56.17 60.46l13.33 20ZM67.93 29.71l-11.75 17.6ZM56.18 47.31l-4.39 6.57ZM51.79 53.88l4.38 6.58zM56.17 60.45l-4.38-6.57 4.38 6.58z",
  className: "Logo-Xplora_svg__cls-4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M102.75 0H9.46A9.47 9.47 0 0 0 0 9.47v92.13a9.47 9.47 0 0 0 9.46 9.47h93.29a9.47 9.47 0 0 0 9.46-9.47V9.47A9.47 9.47 0 0 0 102.75 0M44.37 29.71l9.41 14-4.39 6.59-13.82-20.59Zm5 27.75 4.4 6.54-11.05 16.48h-8.79Zm29.1 23h-9l-13.34-20-4.38-6.58 4.39-6.57 11.75-17.6h8.79l-16.1 24.16 17.91 26.61Zm9.67-1.81a3.2 3.2 0 0 1-.72 1 3.36 3.36 0 0 1-5.45-1 3.1 3.1 0 0 1-.27-1.29 3.15 3.15 0 0 1 .27-1.3A3.3 3.3 0 0 1 82.7 75a3.4 3.4 0 0 1 1.06-.71 3.3 3.3 0 0 1 2.61 0 3.4 3.4 0 0 1 1.06.71 3.1 3.1 0 0 1 .72 1.06 3.15 3.15 0 0 1 .27 1.3 3.1 3.1 0 0 1-.27 1.29",
  className: "Logo-Xplora_svg__cls-4"
}))));
export default SvgLogoXplora;